module.exports = function (answer, name, value) {
  if (answer == null) {
    return helpers.answer.call(this, name, value);
  }

  return answer;
};
